import { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { supabase } from '../lib/supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess('Password updated! You can now log in.');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minHeight="100vh" display="flex" alignItems="center" justifyContent="center" bgcolor="#f5f5f5">
      <Card sx={{ minWidth: { xs: '100%', sm: 350 }, p: { xs: 2, sm: 4 } }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>Reset Password</Typography>
          <form onSubmit={handleResetPassword}>
            <Stack spacing={2}>
              <TextField
                label="New Password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                fullWidth
              />
              <TextField
                label="Confirm New Password"
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
                fullWidth
              />
              {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>}
              <Button
                type="submit"
                variant="contained"
                color="error"
                disabled={loading}
                fullWidth
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </Button>
              <Button
                color="error"
                onClick={() => navigate('/login')}
                fullWidth
              >
                Back to Login
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
} 